import { CONSENT_STATUS_REJECTED } from '../constants';
function shouldDisplay(status) {
  return status.toLowerCase() !== CONSENT_STATUS_REJECTED;
}
export default shouldDisplay;
//# sourceMappingURL=shouldDisplay.js.map